import { render, staticRenderFns } from "./CleaningForm2.vue?vue&type=template&id=af85a686"
import script from "./CleaningForm2.vue?vue&type=script&lang=js"
export * from "./CleaningForm2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports